export function megabytes(value: number): number {
  return value * 1024 * 1024;
}
